import { Box, Button, Modal } from "fds";
import "./index.scss";
import utilsCommon from "../../shared/utils/common";
import { DeptInfo, User } from "../../types/adminDept";

import { t } from "i18next";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { useEffect, useState } from "react";

const DeleteUserOrDept = ({
  deleteUserInfo,
  deleteDeptInfo,
  onClose,
  onDelete,
}: {
  deleteUserInfo: User[];
  deleteDeptInfo: DeptInfo;
  onClose?: () => void;
  onDelete: () => void;
}) => {
  const { checkCheckoutUser } = useWorkgroupStore();
  const [status, changeStatus] = useState(deleteUserInfo.length > 0 ? -1 : 0); // -1: 검사 진행 전, 0 : 체크아웃 검사 후 없음, 1: 체크아웃 사용자 있음
  const [checkoutuser, changeCheckoutUser] = useState<any[]>([]); // 체크아웃 사용자
  useEffect(() => {
    if (deleteUserInfo.length > 0)
      checkCheckoutUser(deleteUserInfo.map((item) => item.id)).then(
        (resp: any) => {
          changeCheckoutUser(resp.payload);
          changeStatus(resp.payload?.length);
        }
      );
    else changeStatus(0);
  }, [deleteUserInfo]);
  return (
    <Modal
      width={490}
      footer={
        <Box justifyContent="flex-end">
          <Button
            label={t("admin.common.button.cancel")}
            type="secondary"
            btnStyle="fill"
            onClick={onClose}
          />
          <Button
            label={t("admin.common.button.delete")}
            state={status >= 0 ? "default" : "disable"}
            type="error"
            btnStyle="fill"
            onClick={onDelete}
          />
        </Box>
      }
      title={
        status > 0
          ? t("admin.dept.checkoutDeleteTitle")
          : deleteUserInfo.length > 0
          ? t("admin.dept.deleteUser")
          : t("admin.dept.deleteDept")
      }
      subTitle={
        status > 0
          ? ""
          : deleteUserInfo.length > 0
          ? t("admin.dept.selectDeleteUser", {
              user:
                deleteUserInfo.length === 1
                  ? utilsCommon.getNameWithId(
                      deleteUserInfo[0].name,
                      deleteUserInfo[0].id
                    )
                  : t("admin.dept.usreNameWithCount", {
                      userName: utilsCommon.getNameWithId(
                        deleteUserInfo[0].name,
                        deleteUserInfo[0].id
                      ),
                      count: deleteUserInfo.length - 1,
                    }),
            })
          : t("admin.dept.selectDeleteDept", {
              dept: deleteDeptInfo?.name + "",
            })
      }
      open={deleteUserInfo.length > 0 || deleteDeptInfo?.code !== ""}
      onClose={onClose}
      bodyMsg={
        status > 0
          ? checkoutuser.length === 1
            ? t("admin.dept.checkoutDeleteBodyMany", {
                0: utilsCommon.getNameWithId(
                  checkoutuser[0].userName,
                  checkoutuser[0].userId
                ),
              })
            : t("admin.dept.checkoutDeleteBodyOne", {
                0: utilsCommon.getNameWithId(
                  checkoutuser[0].userName,
                  checkoutuser[0].userId
                ),
                1: checkCheckoutUser.length - 1,
              })
          : deleteUserInfo.length > 0
          ? t("admin.dept.deleteUserMessage")
          : t("admin.dept.deleteDeptMessage")
      }
    />
  );
};

export default DeleteUserOrDept;
